import Output       from '../../Output';
import ColorPreview from '../../Options/ColorPreview';
import kebabCase    from '../../../../../Lib/helpers/kebabCase';

export default class LineOutput extends Output {

    static availableOptions = [ColorPreview];

}